import { render, staticRenderFns } from "./Active.vue?vue&type=template&id=b680d2a0"
import script from "./Active.vue?vue&type=script&lang=js"
export * from "./Active.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports